import { RecordContextType } from "../../../components/record/Record";
import { pdf } from "@react-pdf/renderer";
import { TreatmentPrescriptionDocument } from "./TreatmentPrescriptionDocument";
import React from "react";
import { treatmentPrescriptionExtraOptions, treatmentPrescriptionFieldsQuery } from "../treatment-prescription/utils";
import { api } from "../../../api/config";
import { makeClinicInfo } from "../../../utils/makeClinicInfo";
import { makeTechnicianInfo } from "../../../utils/makeTechnicianInfo";
import { getField } from "../../../api/useField";
import { formatField } from "../../../utils/formatFields";
import { replaceUserForSignatures } from "../../../components/pdf/replaceUserForSignatures";

export const generateTreatmentPrescriptionPdf = async (context: RecordContextType) => {
    const treatmentPrescriptionId = context.item.treatment_prescription?.[0]?.id;
    if (!treatmentPrescriptionId) {
        throw new Error("Este tratamento não tem Prescrição de Tratamento");
    }
    
    const clientFirstName = context.item.client?.user_id?.first_name || "cliente";
    const clientLastName = context.item.client?.user_id?.last_name || "";

    const fieldsToAdd = ["user_created.technician_id.signature,user_created.technician_id.main_professional_title,user_created.technician_id.license_number"]

    const treatmentPrescriptionResponse = await api.get(`items/treatment_prescription/${treatmentPrescriptionId}`, {
        params: {
            fields: [treatmentPrescriptionFieldsQuery, ...fieldsToAdd].join(","),
            ...treatmentPrescriptionExtraOptions.deep
        }
    });

    const treatmentPrescription = treatmentPrescriptionResponse.data.data;

    const clinicsResponse = await api.get("items/clinics", {
        params: {
            fields: "id,name,color,moloni_serie,receptionist.phone,receptionist.first_name,receptionist.last_name,recepcionist.*",
            filter: {
                id: {
                    _neq: 2 // ignore virtual
                }
            }
        }
    });
    
    const clinics = makeClinicInfo(clinicsResponse?.data?.data)

    const rawMainProfessionalTitleField = await getField("technicians", "main_professional_title");
    const mainProfessionalTitleField = formatField(rawMainProfessionalTitleField);

    const prescriberUserData = await replaceUserForSignatures(treatmentPrescription.user_created);
    const prescriberTechnician = makeTechnicianInfo(prescriberUserData, mainProfessionalTitleField)

    const blob = await pdf(
        React.createElement(TreatmentPrescriptionDocument, {
            treatmentPrescription: treatmentPrescription,
            clinics: clinics,
            prescriberTechnician: prescriberTechnician,
        }) as any
    ).toBlob();


    const result = {
        blob,
        clientFirstName,
        clientLastName
    };

    return result;
};
